import {transient} from 'quickstart/system'
import {UnprefixTransientProps} from 'quickstart/types'
import {ComponentProps, forwardRef} from 'react'
import * as S from './styles'

type DigestProps = UnprefixTransientProps<ComponentProps<typeof S.Digest>>

const _Digest = forwardRef<any, DigestProps>((props, ref) => (
  <S.Digest {...props} ref={ref} />
))

type GroupProps = UnprefixTransientProps<ComponentProps<typeof S.Group>>

const Group = forwardRef<any, GroupProps>(
  ({background, foreground, linkColor, size, ...props}, ref) => (
    <S.Group
      {...props}
      {...transient({background, foreground, linkColor, size})}
      ref={ref}
    />
  ),
)

export const Digest = Object.assign(_Digest, {
  Heading: S.Heading,
  Snippet: S.Snippet,
  Group,
})
